import BillingPortalRedirectContainer from './BillingPortalRedirectContainer';

export default BillingPortalRedirectContainer;
